import React from 'react';

const HOURS = Array.from({ length: 12 }, (_, i) => String(i + 1));
const MINUTES = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'));

function PreferredTimePicker({
  idPrefix = 'preferredTime',
  hour,
  minute,
  period,
  onChange,
  disabled = false,
  required = false,
}) {
  const handleHour = (e) => onChange({ hour: e.target.value, minute, period });
  const handleMinute = (e) => onChange({ hour, minute: e.target.value, period });
  const handlePeriod = (e) => onChange({ hour, minute, period: e.target.value });

  return (
    <div className="preferred-time-picker">
      <select
        className="form-select preferred-time-hour"
        id={`${idPrefix}-hour`}
        value={hour}
        onChange={handleHour}
        disabled={disabled}
        required={required && !hour}
        aria-label="Hour"
      >
        <option value="">Hour</option>
        {HOURS.map((h) => (
          <option key={h} value={h}>
            {h}
          </option>
        ))}
      </select>
      <span className="preferred-time-separator">:</span>
      <select
        className="form-select preferred-time-minute"
        id={`${idPrefix}-minute`}
        value={minute}
        onChange={handleMinute}
        disabled={disabled}
        required={required && !minute}
        aria-label="Minute"
      >
        <option value="">Min</option>
        {MINUTES.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </select>
      <select
        className="form-select preferred-time-period"
        id={`${idPrefix}-period`}
        value={period}
        onChange={handlePeriod}
        disabled={disabled}
        required={required}
        aria-label="AM or PM"
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
}

export default PreferredTimePicker;
